/*
 * Constants.
 */

export const bootPath = '/boot/app/7';
